// extracted by mini-css-extract-plugin
module.exports = {"MsgDiv":"MessageACK_MsgDiv__3JEXH","MsgHeader":"MessageACK_MsgHeader__2eYux","MsgACK":"MessageACK_MsgACK__redB7","BtnOK":"MessageACK_BtnOK__3Bad_"};